import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const tcpAuthSessionResponseSchema = jsonObject
export const tcpAuthLogoutResponseSchema = jsonObject
export type TcpAuthSessionResponse = z.infer<typeof tcpAuthSessionResponseSchema>
export type TcpAuthLogoutResponse = z.infer<typeof tcpAuthLogoutResponseSchema>
